import { AssetCategoryWithElementsType } from './types';

// Formal
const UNIFORMS_FORMAL = [
  'Ascot Racing',
  'Ball Gown',
  'Bowler Hat',
  'Business Suit',
  'Cocktail Dress',
  'Dinner Jacket/Tuxedo - Black',
  'Dinner Jacket/Tuxedo - White',
  'Evening Dress',
  'Morning Suit',
  'Pinstripe Suit',
  'Three Piece Black Suit',
  'Top Hat and Tails',
  'Tweeds',
  'Wedding Guest Outfit',
];

const UNIFORMS_FORMAL_CATEGORY = {
  label: 'Formal',
  list: UNIFORMS_FORMAL,
};

// Police
const UNIFORMS_POLICE = [
  'Met Police Uniform Current',
  'British Transport Police',
  'New National Police Uniform',
  'Regional Police Uniform',
  'Met Police Uniform - Old Fashioned',
  'Tunic Uniform - Old Fashioned',
  'Tunic Uniform - Ceremonial',
  'Riot Gear',
  'SO19',
  'ARV (Armed Response)',
  'PCSO (Community Officer)',
  'Police Dog Handler',
  'Police Traffic Cop',
  'Police Motorbike Gear',
];

const UNIFORMS_POLICE_CATEGORY = {
  label: 'Uniforms - Police',
  list: UNIFORMS_POLICE,
};

// Other Emergency Services
const UNIFORMS_OTHER_EMERGENCY_SERVICES = [
  'Dentist',
  'Doctor',
  'Medical Scrubs',
  'Nurse',
  'Paramedic Full uniform',
  'Real FireFighter',
  'St Johns Ambulance',
];

const UNIFORMS_OTHER_EMERGENCY_SERVICES_CATEGORY = {
  label: 'Uniforms - Other Emergency Services',
  list: UNIFORMS_OTHER_EMERGENCY_SERVICES,
};

// Military
const UNIFORMS_MILITARY = [
  'Army',
  'Navy',
  'RAF',
  'Merchant Navy',
  'Foreign Forces',
];

const UNIFORMS_MILITARY_CATEGORY = {
  label: 'Uniforms - Military',
  list: UNIFORMS_MILITARY,
};

// Transport
const UNIFORMS_TRANSPORT = [
  'Bus Driver',
  'Cabin Crew',
  'Chauffeur',
  'Pilot',
  'Railway',
  'Traffic Warden',
  'London Underground',
];

const UNIFORMS_TRANSPORT_CATEGORY = {
  label: 'Uniforms - Transport',
  list: UNIFORMS_TRANSPORT,
};

// Other
const UNIFORMS_OTHER = [
  'Academic Robes',
  'Customs Officer',
  'Lollypop',
  'Postman',
  'Prison Warden',
  'Security Guard',
  'Tabard',
  'School Uniform',
  'Girl Guide',
  'Scout',
];

const UNIFORMS_OTHER_CATEGORY = {
  label: 'Uniforms - Other',
  list: UNIFORMS_OTHER,
};

// Jobs & Fashion
const UNIFORMS_JOBS_AND_FASHION = [
  'Auctioneer',
  'Barrister',
  'Beautician',
  'Bee Keeper',
  'Belly Dancer',
  'Biker (with Leathers)',
  'Boiler Suit',
  'Builder',
  'Butler',
  'Burlesque',
  'Carnival',
  'Courier - Motorbike',
  'Courier - Pushbike',
  'Chef Whites',
  'Cheerleader',
  'Circus',
  'Clown',
  'Clubbing',
  'Cyber-punk',
  'Decorator',
  'Drag',
  'Emo',
  'Father Christmas',
  'Fancy Dress',
  'Farmer',
  'Fetish',
  'Fetish - Nurse',
  'Fisherman',
  'Flamenco',
  'Glam Rock',
  'Goth',
  'Hippy',
  'Lifeguard',
  'Magician',
  'Maid',
  'Mechanic',
  'Mod',
  'New Romantics',
  'Panto',
  'Pearly Queen/King',
  'Punk',
  'Raver',
  'Rockers',
  'Skaters/Surf',
  'Skin Head',
  'Teddy Boy',
  'Tramp',
  'Town Cryer',
  'Undertaker',
  'Waiter',
  'Waitress',
];

const UNIFORMS_JOBS_AND_FASHION_CATEGORY = {
  label: 'Jobs & Fashion Styles',
  list: UNIFORMS_JOBS_AND_FASHION,
};

// Sports
const UNIFORMS_SPORTS = [
  'American Football',
  'Archery',
  'Athletics',
  'Athletics Running Spikes',
  'Ballet',
  'Badminton',
  'Baseball',
  'Basketball',
  'Boxing',
  'Bowling Whites',
  'Climbing Gear',
  'Cricket Whites',
  'Cricket Umpire',
  'Cycling Lycra Gear and Helmet',
  'Diver - Scuba',
  'Equestrian',
  'Football Kit',
  'Football Boots',
  'Fencing',
  'Fishing',
  'Golf',
  'Gym',
  'Gym - Leotard',
  'Hiking Gear',
  'Hockey',
  'Ice Skates',
  'Martial Arts',
  'Motorbike Helmet',
  'Mountain Bike',
  'Netball',
  'Push Scooter',
  'Racing Driver',
  'Referee',
  'Rollerblades (own blades)',
  'Roller Skates (own skates)',
  'Rowing',
  'Rugby Kit',
  'Running Kit',
  'Sailing',
  'Speedos',
  'Skateboard (own board)',
  'Ski',
  'SkyDiving',
  'Snowboarding',
  'Surfboard',
  'Tennis Whites',
  'Wet Suit',
  'Wrestling',
];

const UNIFORMS_SPORTS_CATEGORY = {
  label: 'Sports',
  list: UNIFORMS_SPORTS,
};

// Religious
const UNIFORMS_RELIGIOUS = [
  'Christian - Bishop',
  'Christian - Choir',
  'Christian - Monk',
  'Christian - Nun',
  'Christian - Priest',
  'Christian - Vicar',
  // Hindu
  'Hindu - Kurta',
  // Jewish
  'Jewish - Yarmulka',

  // Muslim
  'Muslim - Abaya',
  'Muslim - Burka',
  'Muslim - Fez',
  'Muslim - Hijab',
  'Muslim - Keffiyeh',
  'Muslim - Taqiyah',
  'Muslim - Thawb / Thobe',
  'Muslim - Ashmak / Niqab',

  //Sikh
  'Sikh - Turban',
  'Sikh - Shalwar Kameez',
];

const UNIFORMS_RELIGIOUS_CATEGORY = {
  label: 'Religious',
  list: UNIFORMS_RELIGIOUS,
};

// National Dress
const UNIFORMS_NATIONAL_DRESS = [
  'African',
  'Asian',
  'Cheongsam',
  'Chinese',
  'Dirndl',
  'Indian',
  'Japanese',
  'Kerbaya',
  'Kilt',
  'Kimono',
  'Mexican',
  'Middle Eastern',
  'Native American',
  'Russian',
  'Sari',
  'Sherwani',
  'South American',
  'Taqiyah',
  'Thai',
  'Yarmulka',
  'Yashmak',
];
const UNIFORMS_NATIONAL_DRESS_CATEGORY = {
  label: 'National Dress',
  list: UNIFORMS_NATIONAL_DRESS,
};

const UNIFORMS_CATEGORIES = [
  UNIFORMS_FORMAL_CATEGORY,
  UNIFORMS_POLICE_CATEGORY,
  UNIFORMS_OTHER_EMERGENCY_SERVICES_CATEGORY,
  UNIFORMS_MILITARY_CATEGORY,
  UNIFORMS_TRANSPORT_CATEGORY,
  UNIFORMS_OTHER_CATEGORY,
  UNIFORMS_JOBS_AND_FASHION_CATEGORY,
  UNIFORMS_SPORTS_CATEGORY,
  UNIFORMS_RELIGIOUS_CATEGORY,
  UNIFORMS_NATIONAL_DRESS_CATEGORY,
];

export const UNIFORMS_CATEGORIES_DETAILED: AssetCategoryWithElementsType[] =
  UNIFORMS_CATEGORIES.map(({ label, list }) => ({
    label,
    list,
  }));
